const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    console.log(entry);
    if (entry.isIntersecting) {
      entry.target.classList.add("show-animate-in-when-visible");
    }
  });
});

const hiddenElements = document.querySelectorAll(
  ".hidden-animate-in-when-visible"
);
hiddenElements.forEach((el) => observer.observe(el));
